export class YmlModel {

  public id?: number;
  public name?: string;
  public priority?: number;
  public file?: string;
  public description?: string;
  public type?: string;
  public country?: string;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.priority = data.priority;
      this.file = data.file;
      this.description = data.description;
      this.type = data.type;
      this.country = data.country;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    } else {
      this.priority = null;
      this.description = '';
      this.type = '';
      this.country = '';
    }
  }

  isValid() {
    return !!this.name && !!this.file;
  }
}
